import React from "react";
import AmazonLog from "./amazon-logo.png";

const TrustedCompany = () => {
  return (
    <div className="flex gap-4 w-full bg-transparent items-end lg:items-center h-full border-b border-b-greyBg justify-center px-4 lg:px-0">
      <div
        className="flex w-full border-t border-l lg:max-w-7xl border-r rounded-t-lg lg:rounded-t-3xl items-center justify-center
       border-[#a0a5e2] bg-white/0 backdrop-blur px-2 pt-2 lg:px-6 lg:pt-6"
      >
        <div
        className="relative flex w-full before:absolute before:h-full before:w-full before:blur-3xl before:bg-[#9884e6] before:-z-10
      "
      >
        <div className="flex flex-col lg:flex-row gap-6 w-full items-center justify-between px-3 pt-3 lg:px-14 lg:pt-14 pb-3 lg:pb-6 rounded lg:rounded-t-lg bg-[#0c101c]">
          <div
            className="flex w-full justify-center items-center"
            data-aos="fade-up"
            data-aos-duration={1000}
            data-aos-delay={600}
          >
            <h1 className="text-xl text-center lg:text-2xl w-full font-bold">
            We are pretty damn good at what we do and trusted by Executives & Entrepreneurs from
            </h1>
          </div>
          <div className="gap-4 lg:gap-12 grid grid-cols-2 lg:flex lg:flex-nowrap">
            <div
              className="h-10 lg:h-14 flex justify-center items-center"
              data-aos="fade-up"
              data-aos-duration={1000}
              data-aos-delay={400}
            >
              <img
                src="https://iconape.com/wp-content/files/ur/370111/svg/google-logo-icon-png-svg.png"
                alt="google"
                className="w-full h-full bg-contain object-contain"
              />
            </div>
            <div
              className="h-10 lg:h-14 hidden md:flex justify-center items-center"
              data-aos="fade-up"
              data-aos-duration={1000}
              data-aos-delay={600}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/1280px-Microsoft_logo_%282012%29.svg.png"
                alt="google"
                className="w-full h-full bg-contain object-contain"
              />
            </div>
            <div
              className="h-10 lg:h-14 flex justify-center items-center bg-white p-2 rounded-lg"
              data-aos="fade-up"
              data-aos-duration={1000}
              data-aos-delay={800}
            >
              <img
                src={AmazonLog}
                alt="amazon"
                className="w-full h-full bg-contain object-contain"
              />
            </div>
            <div
              className="h-10 lg:h-14 hidden lg:flex justify-center items-center bg-black"
              data-aos="fade-up"
              data-aos-duration={1000}
              data-aos-delay={1000}
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/5/57/X_logo_2023_%28white%29.png"
                alt="google"
                className="w-full h-full bg-contain object-contain"
              />
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedCompany;
